import moment from 'moment';
import { FC } from 'react';
import { CloseButton, DialogSubTitle, DialogToolbar } from '../../../../shared/dialog/dialog.styles';
import { withPatientIvStatusDialogProvider } from '../../hooks/use-patient-iv-status-dialog/hoc';
import { usePatientIvStatusDialog } from '../../hooks/use-patient-iv-status-dialog/hook';
import { PatientIvStatusDialog } from '../patient-iv-status-dialog';
import { AppointmentEndedMessage } from '../shared/appointment-ended-message/appointment-ended-message';
import { RunVerificationButton } from '../shared/run-verification-button';
import { SelfPayButton } from '../shared/self-pay-button';
import { BoldText } from '../styles';

const ManuallyVerifiedStatusDialog: FC = () => {
  const { opened, onClose, isLoading, selectedIvSummary, patientInfo, appointment } = usePatientIvStatusDialog();

  return (
    <PatientIvStatusDialog
      opened={opened}
      title="Manually Verified"
      subtitle={
        <>
          <BoldText>{`${patientInfo?.firstName} ${patientInfo?.lastName}`}</BoldText>
          {selectedIvSummary?.dateSubmitted && (
            <>&nbsp;- {moment.utc(selectedIvSummary?.dateSubmitted).local().format('MMM D hA')}</>
          )}
        </>
      }
    >
      <DialogSubTitle sx={{ margin: '10px 0 20px 0', display: 'block' }}>
        This patient was manually verified by&nbsp;
        {selectedIvSummary?.requestingUserFirstName}&nbsp;
        {selectedIvSummary?.requestingUserLastName}.
      </DialogSubTitle>
      <AppointmentEndedMessage />
      <DialogToolbar>
        <SelfPayButton onSuccess={async () => onClose()} disabled={isLoading || appointment?.isEnded} />
        <RunVerificationButton onSuccess={async () => onClose()} disabled={isLoading || appointment?.isEnded} />
        <CloseButton onClick={onClose} disabled={isLoading} />
      </DialogToolbar>
    </PatientIvStatusDialog>
  );
};

export default withPatientIvStatusDialogProvider(ManuallyVerifiedStatusDialog);
